import bookingStore from './store'

export { default as useBookingStore } from './store'

export default bookingStore
